module.exports = __webpack_public_path__ + "media/country_flags/pn-f991d49e.png";